import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';
import { formatDate, getTodayDateISO } from '../../Utils/Common';

import { 
  Layout,
  Col, 
  Row,
  Button,
  Dropdown, 
  Space,
  Modal,
  Form,
  Input,
  InputNumber,
  Switch,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Search } = Input;
const { confirm } = Modal;

const DiscountItems = () => {
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [discountId, setDiscountId] = useState('');
  const [excelData, setExcelData] = useState([])
  const [price, setPrice] = useState(false);
  const [discountData, setDiscountData] = useState([])
  const [addDiscountForm] = Form.useForm();
  const [editDiscountForm] = Form.useForm();

  const [filterConfig, setFilterConfig] = useState({
    search: '',
    page: 1,
  })

  const { callPost, loading } = usePostRequest(()=>{
    fetchTableData()
    addDiscountForm.resetFields();
    editDiscountForm.resetFields();
    setAddVisible(false); 
    setEditVisible(false);
  });

  function ActionBtn(row) {
    const items = [
      {
        label: (
          <div onClick={() => showEditModal(row.row)}>
            Edit
          </div>
        ),
        key: '2',
      },
      {
        label: (
          <div style={{color: 'red'}} onClick={() => showDeleteConfirm(row.row.id)}>
            Delete
          </div>
        ),
        key: '3',
      },
    ];

    return (
      <span className='center'>
        <Dropdown
          menu={{
          items,
          }}
          trigger={['click']}
        >
          <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
            <Space>
              <MoreVert />
            </Space>
          </div>
        </Dropdown>
      </span>
    );
  }

  async function fetchTableData  () {
    setIsLoading(true);
    const response = await UseGetRequest("discount_items/get", filterConfig);
    if (response.data) {
      setDiscountData(response.data.data);
      setPageSize(response?.data?.size)
    } else {
      setDiscountData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData  () {
    setExportLoading(true);
    const response = await UseGetRequest("discount_items/get", 
      {
        search: filterConfig.search,
      }
    );
    if (response.data) {
      const excel_data = response?.data?.data?.map((data) => ({
        id: data.id,
        name: data.name,
        percentage: data.percentage,
        fixed_price: data.fixed_price,
        added_on: data.added_on && formatDate(data.added_on),
        updated_on: data.updated_on && formatDate(data.updated_on),
      }))
      setExcelData(excel_data);
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const handleAddOk = () => {
    addDiscountForm.validateFields().then(values => {
      callPost(
        "discount_items/create", 
        values,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleEditOk = () => {
    editDiscountForm.validateFields().then(values => {
      const reset_data ={
          discount_item_id: discountId,
          name: values.name,
      }
      if(values.percentage){
        reset_data.percentage = values.percentage
        reset_data.fixed_price = ""
      }else{
        reset_data.fixed_price = values.fixed_price
        reset_data.percentage = ""
      }
      callPost(
        "discount_items/update", 
        reset_data,
        false,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure delete this Rental Unit?',
      icon: <ExclamationCircleFilled />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      confirmLoading: loading,
      onOk() {
        callPost(
          "discount_items/delete", 
          {discount_item_id: id},
          false
        );
      },
    });
  };

  const showAddModal = () => {
    setAddVisible(true);
  };

  const showEditModal = (discount_data) => {
    setEditVisible(true);
    setDiscountId(discount_data.id)
    if(discount_data.percentage){
      setPrice(true)
    } else {
      setPrice(false)
    }
    editDiscountForm.setFieldsValue({
      name: discount_data.name,
      percentage: discount_data.percentage,
      fixed_price: discount_data.fixed_price,
    });

  };

  const handleAddCancel = () => {
    setAddVisible(false);
    addDiscountForm.resetFields();
    editDiscountForm.resetFields();
  };

  const handleEditCancel = () => {
    setEditVisible(false);
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  }; 

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchTableData();
    fetchExportData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'discount_item_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={12} className='header-container'>
              DISCOUNT ITEM
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>   
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Name",
                  "Percentage",
                  "Fixed Price",
                  "Added On",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Discount_Item_${getTodayDateISO()}.xlsx`}
              />         
              <Button 
                className='button-color responsive-header-btn' 
                onClick={showAddModal} 
                type="primary"
              >
                + Add Discount Item
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Space span={24} className='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />              
          </Space>
        </Row>
        <Row className='page-content'>
          <Col span={24}>
            <AntDTable
              tableHeaders={[
                "Name",
                "Percentage",
                "Fixed Price",
              ]}
              headerSelector={[
                "name",
                "percentage",
                "fixed_price",
              ]}
              tableData={discountData}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
      <Modal
        title="Add Discount"
        confirmLoading={loading}
        open={addVisible}
        okText="Submit"
        onOk={handleAddOk}
        onCancel={handleAddCancel}
      >
        <Form form={addDiscountForm} layout="vertical">
          <Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter your Name!' }]}
          >
            <Input />
          </Item>
          <Switch
            checked={price}
            checkedChildren="Percentage"
            unCheckedChildren="Fixed Price"
            size='medium'
            className='my-4'
            style={{ backgroundColor: price ? 'green' : '#0e3282' }} // Adjust the colors as needed
            onChange={() => {
                setPrice(!price);
            }}
          />
          {
            price ? (
              <Item
                label="Percentage"
                name="percentage"
                rules={[{ required: true, message: 'Please enter your Percentage!' }]}
              >
                <InputNumber style={{width:'100%'}}/>
              </Item>
            ) : (
              <Item
                className=''
                label="Fixed Price"
                name="fixed_price"
                rules={[{ required: true, message: 'Please enter your Fixed Price!' }]}
              >
                <InputNumber  style={{width:'100%'}}/>
              </Item>
            )
          }    
        </Form>
      </Modal>
      <Modal
        title="Edit Discount"
        confirmLoading={loading}
        open={editVisible}
        okText="Save"
        onOk={handleEditOk}
        onCancel={handleEditCancel}
      >
        <Form form={editDiscountForm} layout="vertical">
          <Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter your Name!' }]}
          >
            <Input />
          </Item>
          <Switch
            checked={price}
            checkedChildren="Percentage"
            unCheckedChildren="Fixed Price"
            size='medium'
            className='my-4'
            style={{ backgroundColor: price ? 'green' : '#0e3282' }} // Adjust the colors as needed
            onChange={() => {
                setPrice(!price);
            }}
          />
          {
            price ? (
              <Item
                label="Percentage"
                name="percentage"
                rules={[{ required: true, message: 'Please enter your Percentage!' }]}
              >
                <InputNumber style={{width:'100%'}}/>
              </Item>
            ) : (
              <Item
                className='mb-4'
                label="Fixed Price"
                name="fixed_price"
                rules={[{ required: true, message: 'Please enter your Fixed Price!' }]}

              >
                <InputNumber  style={{width:'100%'}}/>
              </Item>
            )
          }    
        </Form>
      </Modal>
    </Layout>
  )
}

export default DiscountItems
